var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-container',{staticClass:"pt-5"},[_c('b-card',[_c('b-card-header',[_c('h2',[_vm._v("Maintenance Window")])]),_c('b-card-body',[_c('p',[_vm._v(" The School Performance Reports are temporarily unavailable while we make updates to the site. Please check back for an update. ")])]),_c('b-card-footer')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }